import React, { Component } from 'react'
import { Tab, Tabs } from 'material-ui/Tabs'
import Paper from 'material-ui/Paper'
import { FormattedMessage } from 'react-intl'
import Details from './Details'
import Schedule from './Schedule'
import Invite from './Invite'
import Recording from './Recording'
import Settings from './Settings'
import { checkAdminUrl } from '../../../lib'

class SeminarTabs extends Component {
  constructor (props) {
    super(props)

    this.state = {
      index_0: '#4688F1',
      index_1: '#afb8c5',
      index_2: '#afb8c5',
      index_3: '#afb8c5',
      index_4: '#afb8c5',
      index_5: '#afb8c5'
    }
  }

  handleTabChange = e => {
    const index = e.props.index
    switch (index) {
      case 0:
        this.setState({
          index_0: '#4688F1',
          index_1: '#afb8c5',
          index_2: '#afb8c5',
          index_3: '#afb8c5',
          index_4: '#afb8c5',
          index_5: '#afb8c5'
        })
        break
      case 1:
        this.setState({
          index_1: '#4688F1',
          index_0: '#afb8c5',
          index_2: '#afb8c5',
          index_3: '#afb8c5',
          index_4: '#afb8c5',
          index_5: '#afb8c5'
        })
        break
      case 2:
        this.setState({
          index_2: '#4688F1',
          index_0: '#afb8c5',
          index_1: '#afb8c5',
          index_3: '#afb8c5',
          index_4: '#afb8c5',
          index_5: '#afb8c5'
        })
        break
      case 3:
        this.setState({
          index_3: '#4688F1',
          index_0: '#afb8c5',
          index_2: '#afb8c5',
          index_1: '#afb8c5',
          index_4: '#afb8c5',
          index_5: '#afb8c5'
        })
        break
      case 4:
        this.setState({
          index_4: '#4688F1',
          index_0: '#afb8c5',
          index_2: '#afb8c5',
          index_3: '#afb8c5',
          index_1: '#afb8c5',
          index_5: '#afb8c5'
        })
        break
      default:
        console.log('default')
    }
  }

  render () {
    const {isFetchingPreviousRooms, isFetchingRooms} = this.props
    return (
      <Paper className="vh-75">
        <Tabs
          inkBarStyle={{background: '#4688F1', height: 3}}
          tabItemContainerStyle={{
            backgroundColor: '#FFFFFF',
            color: '#4688F1',
            borderBottom: '1px solid #d9d9d9',
            boxShadow: '0 8px 3px -5px #d9d9d9'
          }}
        >
          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_0}}
            label={<FormattedMessage id="seminarActions.tabs.details"/>}
          >
            <div className="mt4 mb4 flex justify-center items center h-100">
              {isFetchingRooms || isFetchingPreviousRooms ? (
                <div className="h-100">Loading room...</div>
              ) : this.props.isFetchingConferenceDetails ? (
                <div className="h-100">Loading room details...</div>
              ) : (
                <div style={{width: 448, height: 427}}>
                  <Details
                    pathname={this.props.pathname}
                    guest={!checkAdminUrl(this.props.pathname)}
                    selectConferenceId={this.props.selectConferenceId}
                    updateConferenceDetails={this.props.updateConferenceDetails}
                    conferenceDetails={this.props.conferenceDetails}
                  />
                </div>
              )}
            </div>
          </Tab>
          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_1}}
            label={<FormattedMessage id="seminarActions.tabs.schedule"/>}
          >
            <div className="mt4 mb4 flex justify-center items center h-100">
              <div style={{width: 448, height: 427}}>
                <Schedule
                  pathname={this.props.pathname}
                  guest={!checkAdminUrl(this.props.pathname)}
                  startDate={this.props.startDate}
                  scheduleSubmitted={this.props.scheduleSubmitted}
                  scheduleUpdated={this.props.scheduleUpdated}
                  isFetchingConferenceDetails={
                    this.props.isFetchingConferenceDetails
                  }
                  isFetchingRooms={this.props.isFetchingRooms}
                  conferenceDetails={this.props.conferenceDetails}
                  selectConferenceId={this.props.selectConferenceId}
                  updateConferenceSchedule={this.props.updateConferenceSchedule}
                />
              </div>
            </div>
          </Tab>
          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_2}}
            label={<FormattedMessage id="seminarActions.tabs.invite"/>}
          >
            <div className="pa3">
              {isFetchingRooms || isFetchingPreviousRooms ? (
                <div className="h-100">Loading room...</div>
              ) : this.props.isFetchingConferenceDetails ? (
                <div className="h-100">Loading room details...</div>
              ) : (
                <Invite
                  pathname={this.props.pathname}
                  guest={!checkAdminUrl(this.props.pathname)}
                  participants={this.props.participants}
                  addParticipant={this.props.addParticipant}
                  inviteParticipant={this.props.inviteParticipant}
                  deleteParticipant={this.props.deleteParticipant}
                  importParticipants={this.props.importParticipants}
                  isFetchingParticipantList={
                    this.props.isFetchingParticipantList
                  }
                  conferenceDetails={this.props.conferenceDetails}
                  isFetchingList={this.props.isFetchingList}
                  fetchContactList={this.props.fetchContactList}
                  contacts={this.props.contacts}
                  selectConferenceId={this.props.selectConferenceId}
                />
              )}
            </div>
          </Tab>
          {checkAdminUrl(this.props.pathname) && this.props.conferenceDetails.record_flag ? (
            <Tab
              onActive={this.handleTabChange}
              buttonStyle={{color: this.state.index_3}}
              label={<FormattedMessage id="seminarActions.tabs.recording"/>}
            >
              {isFetchingRooms || isFetchingPreviousRooms ? (
                <div className="h-100">Loading room...</div>
              ) : this.props.isFetchingConferenceDetails ? (
                <div className="h-100">Loading room details...</div>
              ) : (
                <Recording
                  pathname={this.props.pathname}
                  isFetchingRecordList={this.props.isFetchingRecordList}
                  recordings={this.props.recordings}
                  selectConferenceId={this.props.selectConferenceId}
                />
              )}
            </Tab>
          ) : (
            ''
          )}
          <Tab
            onActive={this.handleTabChange}
            buttonStyle={{color: this.state.index_4}}
            label={<FormattedMessage id="seminarActions.tabs.settings"/>}
          >
            <div className="flex justify-center mt4">
              {isFetchingRooms || isFetchingPreviousRooms ? (
                <div className="h-100">Loading room...</div>
              ) : this.props.isFetchingConferenceDetails ? (
                <div className="h-100">Loading room details...</div>
              ) : (
                <Settings
                  pathname={this.props.pathname}
                  guest={!checkAdminUrl(this.props.pathname)}
                  isFetchingConferenceDetails={
                    this.props.isFetchingConferenceDetails
                  }
                  isFetchingRooms={this.props.isFetchingRooms}
                  selectConferenceId={this.props.selectConferenceId}
                  conferenceDetails={this.props.conferenceDetails}
                  updateConferenceSettings={this.props.updateConferenceSettings}
                />
              )}
            </div>
          </Tab>
        </Tabs>
      </Paper>
    )
  }
}

export default SeminarTabs



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/SeminarActions.js